import { Box } from "@mui/material";
import { useTableLayoutClasses } from "../TableLayout.style";
import { AppIconsCamera } from "../../../AppIcons";
import ImageTooltip from "../../../AppTooltip/ImageTooltip";

type TImageIconComponent = {
    item: any,
}

const ImageIconComponent = (props: TImageIconComponent) => {

    const classes = useTableLayoutClasses();
    let images: any[] = props.item.images;
    images = images?.filter(i => i && i.imageType === 'photo');
    return (
        <Box sx={[classes.columnReplaced]}>
            {images && images.length > 0 &&
                <ImageTooltip imagePath={images[0].fileName}>
                    <AppIconsCamera />
                </ImageTooltip>
            }
        </Box>
    )
}

export default ImageIconComponent;